<template>
  <span v-if="source" class="d-inline-flex flex-column" style="line-height: 1.2;">
    <span class="d-inline-flex align-items-center text-muted" style="gap: 0.25rem; font-size: 0.8125rem;">
      <i v-if="isSystem" class="bx bx-cog" v-b-tooltip.hover :title="$t('task.source-system-readonly')" />
      {{ typeLabel }}
    </span>
    <span>{{ entityLabel }}</span>
  </span>
  <span v-else class="text-muted">—</span>
</template>

<script>
export default {
  name: "TaskSource",
  props: {
    caused: { type: Object, default: null },
  },
  computed: {
    source() {
      const entity = this.caused?.entity;
      if (!entity) return null;
      // Bilinen tüm caused.entity slot'larında ilk dolu olanı bul.
      for (const type of Object.keys(entity)) {
        if (entity[type] && entity[type]._id) {
          return { type, entity: entity[type] };
        }
      }
      return null;
    },
    isSystem() {
      // Rule var + halen mevcut bir kaynak entity var → sistem üretimi (kilitli görünür)
      return !!(this.caused && this.caused.rule && this.caused.rule._id && this.source);
    },
    typeLabel() {
      const key = `task.source-type.${this.source.type}`;
      const translated = this.$t(key);
      // Eğer i18n'de tanımlı değilse vue-i18n raw key'i döner, o durumda type'ı raw göster.
      return translated === key ? this.source.type : translated;
    },
    entityLabel() {
      const e = this.source.entity;
      if (e.name) {
        return this.$options.filters.translate(e.name);
      }
      if (e.applicationSubject) {
        return this.$options.filters.translate(e.applicationSubject);
      }
      return "—";
    },
  },
};
</script>
